
const hashSha256 = async (value = '') => {
    const encoder = new TextEncoder();
    const data = encoder.encode(value.trim().toLowerCase());
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

const addEventToDataLayerWithHashedEmail = (eventData, email) => {
    hashSha256(email).then(hashedEmail => {
        const pushObj = {
            event: 'der-analytics',
            leadsUserData: {
                sha256_email_address: hashedEmail,
            },
            ...eventData,
        };
        window.dataLayer.push(pushObj);
    }).catch(error => {
        console.error('Hashing-Error:', error);
    });
};

document.addEventListener('der-analytics', (event) => {
    const eventData = event.detail;
    if (!eventData) return;

    window.dataLayer = window.dataLayer || [];

    if (['der-tm-offer-request', 'der-tailormade-offer-request', 'der-tm-appointment-booking', 'der-tailormade-appointment-booking', 'der-tm-booking-request', 'der-tailormade-booking-request'].includes(eventData.element_name)) {
        // form submit btn clicked
        if (['form-submit'].includes(eventData.name) && Object.hasOwn(eventData,'data')) {
            let eventDataClone = JSON.parse(JSON.stringify(eventData));
            // data protection: remove ContactEmail/email before push to dataLayer
            // for der-tailormade-offer-request and der-tailormade-appointment-booking
            if (Object.hasOwn(eventData.data, 'ContactEmail')) {
                delete eventDataClone.data.ContactEmail;
            }
            // for der-tailormade-booking-request
            if (Object.hasOwn(eventData.data, 'email')) {
                delete eventDataClone.data.email;
            }

            const pushObj = {
                event: 'der-analytics',
                ...eventDataClone,
            };
            window.dataLayer.push(pushObj);
            return;
        }

        // form sucessfully submitted
        if (['form-submitted'].includes(eventData.name) && Object.hasOwn(eventData,'data') && Object.hasOwn(eventData.data, 'email')) {
            const email = eventData.data.email;
            // data protection: remove plain text email property
            let eventDataClone = JSON.parse(JSON.stringify(eventData));
            delete eventDataClone.data.email;

            // add hashed email address
            addEventToDataLayerWithHashedEmail(eventDataClone, email)
            return;
        }
    }

    const pushObj = {
        event: 'der-analytics',
        ...eventData,
    };
    window.dataLayer.push(pushObj);
});